export const ReasonsOptions = {
    animal_welfare: 'Animal welfare',
    pornography: 'Pornography/Nudity',
    violence: 'Violence',
    hate: 'Hate',
    misinformation: 'Misinformation',
    bullying_harassment: 'Bullying and harassment',
    threatening_stalking: 'Threatening or stalking',
    private_information: 'Includes private information',
    terrorism: 'Terrorism and violent extremists',
    illegal_activity: 'Illegal content: Illegal activity',
    spam: 'Spam',
    self_harm: 'Promoting self-harm',
    underage_user: 'Underage user',
    graphic_medical_content: 'Graphic medical content',
    disasters_tragedies: 'Disasters and tragedies',
    clips_copyright: 'Clips Copyright',
    coordinated_harm: 'Coordinated harm or threat to life',
    csam: 'CSAM',
    illegal_substances: 'Illegal content: Selling illegal substances/service',
    nonconsensual_image: 'Non-consensual image',
    nonconsensual_deepfake: 'Non-consensual deepfake',
    bullying_harassment_women: 'Bullying and harassment of women',
    threatening_stalking_women: 'Threatening or stalking of women',
    incitement_violence_women: 'Incitement to violence against women',
    discrimination: 'Discrimination',
    copyright: 'Copyright infringement',
    trademark: 'Trademark violation',
    csam_deepfake: 'CSAM deepfake',
    csam_jokes: 'CSAM jokes or mockery',
    public_health: 'Public health',
    eating_disorder: 'Eating disorder',
    mutilation: 'Mutilation',
    solicitation: 'Solicitation',
    incitement_violence_hate: 'Incitement to violence or hate',
    sexual_violence: 'Sexual violence',
    perpetrators: 'Perpetrators of sexual violence',
    school_shootings: 'School shootings',
    epilepsy: 'Epilepsy',
    nudity: 'Nudity',
    real_gore: 'Real gore',
} as const
